import React from 'react';
import { Button, Form, Input, Radio, Select } from 'antd';
import { ReactTransliterate } from "react-transliterate";
import { CloudUploadOutlined } from '@ant-design/icons';
const { Option } = Select;

const CustomTextComponent = ({
    customLanguage,
    setCustomLanguage,
    customMessage,
    setCustomMessage,
    styles,
    showMediaModel,
    buttonStyle,
    setCustomType,
    customType,
    customMediaName
}) => {

    return (
        <>
            <Form.Item
                label="Select Content Type"
                name="content-type"
            >
                <Radio.Group onChange={(e) => setCustomType(e.target.value)} value={customType}>
                    <Radio value='text'>Text</Radio>
                    <Radio value='image'>Image</Radio>
                    <Radio value='video'>Video</Radio>
                    <Radio value='document'>PDF</Radio>
                </Radio.Group>
            </Form.Item>
            {
                customType === 'text' ?
                    (
                        <Form.Item
                            label="Custom Text"
                            name="Custom-Text"
                            rules={[
                                {
                                    required: true,
                                    message: 'This field is required!',
                                },
                            ]}
                        >
                            <Select
                                className="mb-2"
                                defaultValue="en"
                                style={{ width: 120 }}
                                onChange={(value) => setCustomLanguage(value)}
                            >
                                <Option value="en">English</Option>
                                <Option value="gu">Gujarati</Option>
                                <Option value="hi">Hindi</Option>
                            </Select>

                            <ReactTransliterate
                                renderComponent={(props) => (
                                    <textarea
                                        {...props}
                                        rows={4}
                                        className="p-2"
                                        style={styles.textarea}
                                    />
                                )}
                                value={customMessage}
                                onChangeText={(text) => setCustomMessage(text)}
                                lang={customLanguage}
                            />
                        </Form.Item>
                    )
                    :
                    (
                        <Form.Item
                            name={['content', customType]}
                            label={`Select ${customType}`}
                            //rules={[{ required: true, message: 'Please upload a file' }]}
                        >
                            {customMediaName && <Input type="text" disabled value={'Media Selected'} className='mb-3' />}
                            <Button
                                type=""
                                style={buttonStyle}
                                onClick={showMediaModel}
                            >
                                <CloudUploadOutlined />
                                Choose File
                            </Button>
                        </Form.Item>
                    )}
        </>

    );
};

export default CustomTextComponent;
